export default defineNuxtPlugin(() => {
  if (process.client) {
    // Logs client-side errors (runtime, unhandled)
    window.addEventListener('error', (event) => {
      console.error('🟠 Window error:', event.message, event.filename, event.lineno, event.error?.stack)
    })

    window.addEventListener('unhandledrejection', (event) => {
      console.error('🔴 Unhandled Promise Rejection:', event.reason)
    })
  }

  if (process.server) {
    const nuxtApp = useNuxtApp()

    // Logs SSR errors in server logs (Netlify functions)
    nuxtApp.hook('app:error', (error) => {
      console.error('🟣 SSR error caught:', error.stack || error.message || error)
    })
  }
})
